import PropTypes from 'prop-types';

const displayName = 'RepeatOrder';
const propTypes = {
  orders: PropTypes.array,
  onSelect: PropTypes.func,
  isGenesis: PropTypes.bool,
};

const defaultProps = {
  orders: [],
};

export default { displayName, propTypes, defaultProps };
